/*
 * consent/consent.ts — o aviso de cookies e o evento que reabre o painel.
 *
 * O site só guarda no navegador o que é NECESSÁRIO (sessão, segurança e as
 * preferências que a pessoa escolhe), e o necessário não depende de
 * consentimento: há o que informar, uma vez, e nada a perguntar. A única
 * categoria opcional era a publicidade do blog, que saiu com o blog (Onda AC), e
 * com ela o registro da escolha.
 */

/**
 * Dispensa do aviso informativo. Preferência da pessoa, no localStorage — não é
 * registro de consentimento.
 */
export const COOKIE_NOTICE_KEY = 'habilita.cookie-notice';

/**
 * O cookie em que a escolha da publicidade ficava registrada. Sem categoria
 * opcional ele não tem o que guardar e o catálogo não o declara mais; quem ainda
 * o tem o perde na próxima visita, em vez de carregá-lo até vencer (12 meses).
 */
const LEGACY_CONSENT_COOKIE = 'shiba_consent';

/** Apaga o registro antigo da escolha. Idempotente: sem o cookie, nada muda. */
export function clearLegacyConsentCookie(): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${LEGACY_CONSENT_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax`;
}

/** Evento que reabre o painel de preferências de qualquer ponto da interface. */
export const COOKIE_SETTINGS_EVENT = 'shiba:cookie-settings';

export function openCookieSettings(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT));
}
